import React from 'react';
import { MessageSquare, Users, Briefcase, Award } from 'lucide-react';
import { Link } from 'react-router-dom';
export const CommunityStructure = () => {
  return <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-353">
      <div className="container mx-auto px-4" data-id="element-354">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-355">
          Event & Community Structure
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-356">
          <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-357">
            <div className="flex items-center mb-4" data-id="element-358">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-359">
                <MessageSquare size={24} data-id="element-360" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-361">
                The Waiting Room
              </h3>
            </div>
            <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-362">
              <p className="text-gray-600 mb-4" data-id="element-363">
                Free access to our digital ecosystem.
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-364">
                <li data-id="element-365">Connect with others</li>
                <li data-id="element-366">Share ideas</li>
                <li data-id="element-367">Submit approved announcements</li>
              </ul>
            </div>
          </div>
          <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-368">
            <div className="flex items-center mb-4" data-id="element-369">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-370">
                <Users size={24} data-id="element-371" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-372">Event Pathway</h3>
            </div>
            <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-373">
              <p className="text-gray-600 mb-4" data-id="element-374">
                Paid access through in-person participation.
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-375">
                <li data-id="element-376">Access to private community</li>
                <li data-id="element-377">Event-specific discussions</li>
                <li data-id="element-378">Continue connections beyond events</li>
              </ul>
            </div>
          </div>
          <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-379">
            <div className="flex items-center mb-4" data-id="element-380">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-381">
                <Briefcase size={24} data-id="element-382" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-383">
                Inner Circle Membership
              </h3>
            </div>
            <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-384">
              <p className="text-gray-600 mb-4" data-id="element-385">
                Full community membership with premium benefits.
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-386">
                <li data-id="element-387">Masterclasses & masterminds</li>
                <li data-id="element-388">Business development resources</li>
                <li data-id="element-389">Networking with leaders</li>
                <li data-id="element-390">Growth frameworks</li>
              </ul>
            </div>
          </div>
          <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-391">
            <div className="flex items-center mb-4" data-id="element-392">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-393">
                <Award size={24} data-id="element-394" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-395">
                Lifetime Partner Access
              </h3>
            </div>
            <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-396">
              <p className="text-gray-600 mb-4" data-id="element-397">
                Strategic & personalized growth pathway.
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-398">
                <li data-id="element-399">One-on-one strategy sessions</li>
                <li data-id="element-400">Project development handholding</li>
                <li data-id="element-401">Brand feature on platform</li>
                <li data-id="element-402">Exclusive event discounts</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
};